import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./app.css";

import BootLoader from "./components/BootLoader";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Skillsets from "./pages/Skillsets";
import Experience from "./pages/Experience";
import Activity from "./pages/Activity";
import Projects from "./pages/Projects";
import Mentorship from "./pages/Mentorship";
import Achievements from "./pages/Achievements";
import Contact from "./pages/Contact";

function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: true, mirror: false, easing: "ease-in-out" });
  }, []);

  return (
    <div className="app-wrapper">
      {!booted && <BootLoader onDone={() => setBooted(true)} />}

      <div className={`app-content ${booted ? "ready" : "hidden-until-boot"}`}>
        <Navbar />
        <main>
          <Home />
          <About />
          <Skillsets />
          <Experience />
          <Activity />
          <Projects />
          <Mentorship />
          <Achievements />
          <Contact />
        </main>
        <Footer />
        <ToastContainer position="bottom-center" autoClose={3000} closeOnClick pauseOnHover theme="dark" />
      </div>
    </div>
  );
}

export default App;